import type { CoreFetch } from '~/types/CoreFetch'
import type { SeoListing } from '~/types/seoList'

export const provideGetSeoGenericCuratorList = (coreFetch: CoreFetch) => () =>
  coreFetch.$get<SeoListing[]>('/seo/generic_lists/')
